import { createSelector } from 'reselect';
import * as actionItem from '../helpers/actionItem';
import {
  actionTypes as actionConstants,
  auth
} from '../helpers';
import { modal as modalActions } from '../actions';
import { getAnnotationsByAppIdsOrderByDate } from './annotation';

export const getArtifactHealthActions = createSelector(
  getAnnotationsByAppIdsOrderByDate,
  (annotationsByIds) =>
    (app, position) => { return [
      [{
        title: actionConstants.ADD_COMMENT,
        onSelect: modalActions
          .showAddComment(true, app, 0, '', position),
        isDisabled: !auth.checkAuthenticated()
      }],
      [{
        title: actionConstants.SHOW_COMMENTS,
        onSelect: modalActions
          .showCommentHistory(true, app),
        isDisabled: !annotationsByIds[app.id]
      }],
      [{
        title: actionConstants.COPY_DIFF_RESULT_PATH,
        onSelect: actionItem._copyArtifactHealthDiffFilePath(app.platform, app.app.name,
          app.supportedVersion, app.diffVersion),
        isDisabled: app.supportedVersion === app.diffVersion
      }],
      [{
        title: actionConstants.OPEN_DIFF_VIEWER,
        onSelect: actionItem._openArtHealthDiffViewer(app.platform, app.app.name,
          app.supportedVersion, app.diffVersion),
        isDisabled: app.supportedVersion === app.diffVersion
      }]
    ]; }
);


// WEBPACK FOOTER //
// src/selectors/artifactHealth.js